import React, { createContext, useState } from 'react';

export const NavigationContext = createContext();

const NavigationProvider = ({ children }) => {
  const [title, setTitle] = useState('');
  const [subtitle, setSubtitle] = useState('');
  const [tabNavigation, setTabNavigation] = useState([]);
  const [showLogo, setShowLogo] = useState(false);
  const [toolbarSection, setToolbarSection] = useState(null);
  const [headHeight, setHeadHeight] = useState(0);
  const [nextRoute, setNextRoute] = useState(false);

  return (
    <NavigationContext.Provider
      value={{
        title,
        setTitle,
        subtitle,
        setSubtitle,
        tabNavigation,
        setTabNavigation,
        showLogo,
        setShowLogo,
        toolbarSection,
        setToolbarSection,
        headHeight,
        setHeadHeight,
        nextRoute,
        setNextRoute,
      }}
    >
      {children}
    </NavigationContext.Provider>
  );
};

export default NavigationProvider;
